export enum ApplicationStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    DECLINED = "DECLINED",
    ACCEPTED_BY_AMDIN = "ACCEPTED_BY_ADMIN",
    DECLINED_BY_ADMIN = "DECLINED_BY_ADMIN"
}

export function applicationStatusToString(status: ApplicationStatus): string {
    switch (status){
        case ApplicationStatus.PENDING:
            return "Pending";
        case ApplicationStatus.ACCEPTED_BY_AMDIN:
            return "Accepted by admin";
        case ApplicationStatus.ACCEPTED:
            return "Accepted";
        case ApplicationStatus.DECLINED:
            return "Declined";
        case ApplicationStatus.DECLINED_BY_ADMIN:
            return "Declined by admin";
        default:
            return '';
    }
}